import { APP_NAME } from '../../shared/constants.ts';
import { Icon } from '../components/Icon.tsx';
import styles from './LoginPage.module.css';

/** The mark and name at the top of the sign-in, forgot, and reset cards. */
export function AuthBrand() {
  return (
    <div className={styles['brand']}>
      <span className={styles['mark']} aria-hidden="true">
        <Icon name="layers" size="1.4rem" />
      </span>
      <h1 className={styles['title']}>{APP_NAME}</h1>
    </div>
  );
}
